const state = {
    userData: [],
    userStatus:false,
    freeSale:null,//是否是自由销售人
  }
  
  const getters = {
    // globalClick: state => state.click
  }
  
  const actions = {
  
  }
  
  const mutations = {
    setUserData (state, evnt) {
        state.userData  = evnt
        state.freeSale  = evnt&&evnt[0].roleId==7?true:false;//7是自由销售人
    },
    setUserStatus (state, evnt) {
      state.userStatus  = evnt
  },
  }
  
  export default {
    state,
    getters,
    actions,
    mutations
  }
  


// WEBPACK FOOTER //
// ./src/TASMini/store/modules/user.js